import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/cfops.js';
import form from '../forms/cfops.js';
import * as types from '../types.js';

const cfops = function()
{
	let cfops_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_cfops, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_cfop, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				code: String(data.code).trim(),
				description: String(data.description).trim(),
				venda: !!data.venda,
				icms: String(data.icms || '').trim(),
				ipi: data.ipi ? String(data.ipi).trim() : null,
				pis: data.pis ? String(data.pis).trim() : null,
				cofins: data.cofins ? String(data.cofins).trim() : null,
				operacao: data.operacao ? String(data.operacao).trim() : null,
				destino: data.destino ? String(data.destino).trim() : null,
				finalidade: data.finalidade ? String(data.finalidade).trim() : null,
			};
			if (old_data)
				return await api.call(api.update_cfop, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_cfop, data.company_id, _record);
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'CFOP', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do CFOP' },
		{ index: 3, field: 'code', label: 'Código', types: [], placeholder: '5102', title: 'Código CFOP (4 dígitos)' },
		{ index: 4, field: 'description', label: 'Descrição', types: [], placeholder: '', title: 'Descrição' },
		{ index: 5, field: 'venda', label: 'Venda', types: [types.checkbox()], placeholder: '', title: 'Operação de venda' },
	];

	cfops_crud.run(
		'cfops',
		'CFOPs',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);
};

export default cfops;
